import {useEffect, useState} from "react";
import {FaArrowDown} from "react-icons/fa"
import DetailsBookingList from "./DetailsBookingList";
import {motion} from "framer-motion";
import {ITransaction} from "../../utils/interfaces/ITransaction";
import DetailsTransactionList from "./DetailsTransactionList";


interface TransactionProps {
    obj: ITransaction,
}

function Transactions({obj: initialObj}: TransactionProps) {
    const [obj, setObj] = useState<ITransaction>(initialObj)
    const [openDetails, setOpenDetails] = useState<boolean>(false)

    let labelStyle = 'text-sm text-gray-500 font-bold mr-1 cursor-pointer ';
    let contentStyle = 'text-sm text-gray-800 font-bold mr-1 cursor-pointer ';

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            <motion.div
                className="bg-mcia_gray_soft shadow-xl rounded-lg p-4 mb-4 w-[800px] relative"
                initial={{x: '150%'}}
                animate={{x: '0%'}}
                transition={{duration: 0.2}}
            >


                <div className="grid grid-cols-2 gap-2">
                    <div>
                        <h2 className={labelStyle}>Ordini:</h2>
                    </div>
                    <div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Count: </label>
                            <label className={contentStyle}>{obj.totals.count}</label>
                        </div>

                        <div className="flex flex-row">
                            <label className={labelStyle}>Total Net Amount: </label>
                            <label className={contentStyle}>{obj.totals.net_amount.toFixed(2) + ' €'}</label>
                        </div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Total Mycia Commission Amount: </label>
                            <label
                                className={contentStyle}>{obj.totals.total_mycia_commission_amount.toFixed(2) + ' €'}</label>
                        </div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Total Stripe Commission Amount: </label>
                            <label
                                className={contentStyle}>{obj.totals.total_stripe_commission_amount.toFixed(2) + ' €'}</label>
                        </div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Total Commission Amount: </label>
                            <label
                                className={contentStyle}>{obj.totals.total_commission_amount.toFixed(2) + ' €'}</label>
                        </div>
                        <div className="flex flex-row">
                            <label className={labelStyle}>Saldo: </label>
                            <label
                                className={contentStyle}>{obj.totals.balance.toFixed(2) + ' €'}</label>
                        </div>
                    </div>
                </div>

                {obj.details.length > 0 ?
                    <button
                        className="mycia_accounting_button mb-0.5 w-[200px] absolute bottom-2 left-2 flex items-center justify-between shadow-xl"
                        onClick={() => setOpenDetails(!openDetails)}
                    >
                        {openDetails ? <span>Close Details</span> : <span>Open Details</span>}
                        <span className="mr-2">
                        <FaArrowDown
                            className={openDetails ? 'rotate-180 duration-300' : 'rotate-0 duration-300'}/>
                    </span>
                    </button>
                    : ''}


            </motion.div>

            {openDetails ? <DetailsTransactionList obj={obj}/> : ''}
        </>

    )
}

export default Transactions;